import { useMemo } from 'react';
import { get } from 'lodash';
import { useRideHealthConfig } from 'src/components/Contacts/components/useRideHealth';
import { useNotes } from '../queries';
import { getDisplayNotes, getUpdatedNotes } from '../utils/notesUtils';

const usePreparedNotes = ({
  isClientsDrawer,
  providerId,
  rideHealthLinkMapping,
  subject,
  subjectType,
}) => {
  const {
    response,
    notes,
    page,
    pageSize,
    setPageNumber,
    setPageSize,
    isLoading,
  } = useNotes({
    subject,
    subjectType,
    providerId,
  });
  const { rideHealthConfig } = useRideHealthConfig(
    subject,
    subjectType,
    rideHealthLinkMapping,
  );

  const paging = useMemo(() => get(response, 'data.paging', {}), [response]);
  const updatedNotes = useMemo(
    () => getUpdatedNotes(notes, rideHealthConfig),
    [notes, rideHealthConfig],
  );
  const displayNotes = useMemo(
    () => getDisplayNotes(updatedNotes, isClientsDrawer),
    [updatedNotes, isClientsDrawer],
  );

  return {
    displayNotes,
    isLoading,
    page,
    pageSize,
    paging,
    rideHealthConfig,
    setPageNumber,
    setPageSize,
  };
};

export default usePreparedNotes;
